import Item from './Item';


class FrontRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order: 0,
            display:true
        };

    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);

        const lazyImageObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const lazyImage = entry.target;
                    lazyImage.style.backgroundImage = lazyImage.dataset.url;
                    lazyImage.classList.remove('lazy');
                    lazyImageObserver.unobserve(lazyImage);
                }
            })
        })

        const lazyImages = document.querySelectorAll('.lazy-loaded-image.lazy');
        lazyImages.forEach(lazyImage => { lazyImageObserver.observe(lazyImage) });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions=()=>{
        let width = document.getElementById("tab");
        let card = document.querySelector('.card')
        if (card){
            this.setState({
                order: Math.round((width.clientWidth / card.clientWidth) -3) ,
            });
        }else {
            this.setState({
                order: Math.round((width.clientWidth / 200) -3),
            });
        }

        if(this.props.item !== undefined){
            if(Math.round((width.clientWidth / card.clientWidth)-3) > this.props.item.length  ) {
                this.setState({
                    display: false,
                });
            }
        }



    }
    render(item = this.props.item) {
                return (
                    <React.Fragment>
                        {item?
                            <React.Fragment>
                                <section className={'grid-x small-12 medium-12 large-12 cell front-view'}>
                                    <a href={this.props.url} alt={this.props.title} className={'front-title'}><h3 className={'small-12 medium-12 large-12 cell'}>{this.props.title}</h3></a>
                                    <section className={'front-item-row grid-x small-12 medium-12 large-12 cell'}>
                                        {item.map((item,index) => {
                                            return (
                                                <Item
                                                    index={index}
                                                    key={item.id}
                                                    id={item.id}
                                                    owner={item.owner}
                                                    type={item.type}
                                                    subtype={item.subtype}
                                                    status={item.status}
                                                    image={item.image}
                                                    name={item.name}
                                                    county={item.county}
                                                    price={item.price}
                                                    date={item.date}
                                                    startDate={item.start_date}
                                                    endDate={item.end_date}
                                                    link={item.link}
                                                    external_link={item.external_link}
                                                    auctionType={this.props.auctionType}
                                                />
                                            )
                                        })
                                        }
                                        <a className={this.state.display ? 'grid-x' : 'hide'} style={{order:this.state.order}} href={this.props.url} alt={this.props.title}><section className="cell hidden-xs siin grid-x vaata-veel card"><span>{LANG['Vaata veel'] || 'Vaata veel'}</span></section></a>
                                    </section>
                                </section>
                            </React.Fragment>

                            : ''}
                    </React.Fragment>
              )}
}


export default FrontRow;